
export const FETCH_DATA_NOTIFICATION_REQUEST = 'FETCH_DATA_NOTIFICATION_REQUEST';
export const FETCH_DATA_NOTIFICATION_SUCCESS = 'FETCH_DATA_NOTIFICATION_SUCCESS';
export const FETCH_DATA_NOTIFICATION_ERROR = 'FETCH_DATA_NOTIFICATION_ERROR';

export const UPDATE_SETTING_NOTIFICATION_REQUEST = 'UPDATE_SETTING_NOTIFICATION_REQUEST';
export const UPDATE_SETTING_NOTIFICATION_SUCCESS = 'UPDATE_SETTING_NOTIFICATION_SUCCESS';
export const UPDATE_SETTING_NOTIFICATION_ERROR = 'UPDATE_SETTING_NOTIFICATION_ERROR';

export const READ_NOTIFICATION_REQUEST = 'READ_NOTIFICATION_REQUEST';
export const READ_NOTIFICATION_SUCCESS = 'READ_NOTIFICATION_SUCCESS';
export const READ_NOTIFICATION_ERROR = 'READ_NOTIFICATION_ERROR';

export const GET_BADGE_NOTIFICATION_REQUEST = 'GET_BADGE_NOTIFICATION_REQUEST';
export const GET_BADGE_NOTIFICATION_SUCCESS = 'GET_BADGE_NOTIFICATION_SUCCESS';
export const GET_BADGE_NOTIFICATION_ERROR = 'GET_BADGE_NOTIFICATION_ERROR';

export const fetchListNotificationRequest = (data: any) => ({
    type: FETCH_DATA_NOTIFICATION_REQUEST,
    payload: data,
});

export const fetchListNotificationSuccess = (data: any) => ({
    type: FETCH_DATA_NOTIFICATION_SUCCESS,
    payload: data,
});

export const fetchListNotificationError = (error: any) => ({
    type: FETCH_DATA_NOTIFICATION_ERROR,
    payload: error,
});

export const updateSettingNotificationRequest = (data: any) => ({
    type: UPDATE_SETTING_NOTIFICATION_REQUEST,
    payload: data,
});

export const updateSettingNotificationSuccess = (data: any) => ({
    type: UPDATE_SETTING_NOTIFICATION_SUCCESS,
    payload: data,
});

export const updateSettingNotificationError = (error: any) => ({
    type: UPDATE_SETTING_NOTIFICATION_ERROR,
    payload: error,
});


export const readNotificationRequest = (param: any) => ({
    type: READ_NOTIFICATION_REQUEST,
    payload: param,
});

export const readNotificationSuccess = (data: any) => ({
    type: READ_NOTIFICATION_SUCCESS,
    payload: data,
});

export const readNotificationError = (error: any) => ({
    type: READ_NOTIFICATION_ERROR,
    payload: error,
});


export const getBadgeNotificationRequest = () => ({
    type: GET_BADGE_NOTIFICATION_REQUEST,
});

export const getBadgeNotificationSuccess = (data: any) => ({
    type: GET_BADGE_NOTIFICATION_SUCCESS,
    payload: data,
});

export const getBadgeNotificationError = (error: any) => ({
    type: GET_BADGE_NOTIFICATION_ERROR,
    payload: error,
});
